(function () {
  function slugify(value) {
    var slug = value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return slug || 'section';
  }

  function uniqueId(base, used) {
    var id = base;
    var count = 2;
    while (used[id]) {
      id = base + '-' + count;
      count += 1;
    }
    used[id] = true;
    return id;
  }

  function enhancePolicyPage() {
    var root = document.querySelector('.shopify-policy__container');
    if (!root || root.dataset.icsPolicyEnhanced === 'true') return;

    var title = root.querySelector('.shopify-policy__title');
    var body = root.querySelector('.shopify-policy__body');
    if (!title || !body) return;

    root.dataset.icsPolicyEnhanced = 'true';
    root.classList.add('ics-policy-page');
    root.id = 'ics-policy-top';

    var updatedSource = Array.prototype.slice.call(body.querySelectorAll('p')).find(function (paragraph) {
      return /^last updated\s*:/i.test(paragraph.textContent.trim());
    });
    var existingUpdated = title.querySelector('.ics-policy__updated');
    if (!existingUpdated && updatedSource) {
      var updated = document.createElement('p');
      updated.className = 'ics-policy__updated';
      updated.textContent = updatedSource.textContent.trim();
      title.appendChild(updated);
    }
    if (updatedSource) updatedSource.remove();

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3')).filter(function (heading) {
      return heading.textContent.trim();
    });
    var content = document.createElement('div');
    content.className = 'ics-policy__content';
    root.insertBefore(content, body);

    if (headings.length >= 2) {
      var usedIds = {};
      var toc = document.createElement('nav');
      toc.className = 'ics-policy__toc';
      toc.setAttribute('aria-label', 'On this page');
      var details = document.createElement('details');
      details.open = true;
      var summary = document.createElement('summary');
      summary.textContent = 'On this page';
      var list = document.createElement('ol');

      headings.forEach(function (heading) {
        var id = heading.id || uniqueId('policy-' + slugify(heading.textContent), usedIds);
        heading.id = id;
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + id;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
      });

      details.appendChild(summary);
      details.appendChild(list);
      toc.appendChild(details);
      content.appendChild(toc);
    } else {
      content.classList.add('ics-policy__content--single');
    }

    content.appendChild(body);

    var footer = document.createElement('div');
    footer.className = 'ics-policy__footer';
    footer.innerHTML =
      '<p class="ics-policy__footer-note">Questions about this policy?</p>' +
      '<a class="ics-policy__contact" href="/pages/contact">Contact Us</a>' +
      '<a class="ics-policy__top" href="#ics-policy-top">Back to top</a>';
    root.appendChild(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancePolicyPage);
  } else {
    enhancePolicyPage();
  }
})();
